import { ChangeDetectionStrategy, Component, ViewEncapsulation, inject } from '@angular/core';
import { TUI_DARK_MODE } from '@taiga-ui/core';

import { ThemeSwitcherService } from '../../services/theme-switcher.service';

@Component({
  selector: 'app-theme-switcher',
  templateUrl: './theme-switcher.component.html',
  styleUrls: ['./theme-switcher.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThemeSwitcherComponent {
  private readonly themeSwitcherService = inject(ThemeSwitcherService);
  protected readonly darkMode = inject(TUI_DARK_MODE);

  onThemeChange(value: boolean) {
    this.themeSwitcherService.setTheme(value);
  }
}
